
/* eslint-disable react/destructuring-assignment , no-nested-ternary, jsx-a11y/label-has-associated-control, no-console */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './View.Style';

import {
  ReactFormBuilder,
  Registry,
  ReactFormGenerator,
  ElementStore,
} from './react-form-builder-innovate/src/index';

import './react-form-builder-innovate/src/react-form-builder.css';

import FormElementsEdit from './form-elements-edit';
import Modal from './Modal';
import RichEditor from './RichEditor';
import { FormbuilderPre } from './FormbuilderPre';

import RichTextEditorField from "./RichTextEditorField";



/* ----- custom elements registration (unchanged) ----- */
const SpaceComponent = (props) => {
  const { heightValue } = props.data || {};
  return <div style={{ height: `${heightValue || 16}px` }} />;
};

const TextInputComponent = React.forwardRef((props, ref) => {
  const { name, defaultValue, disabled, data, ...rest } = props || {};
  return (
    <div className="labelgroup">
      <input
        style={{ width: '100%', minHeight: '2.8rem', padding: '0.5rem', boxSizing: 'border-box' }}
        ref={ref}
        name={name}
        defaultValue={defaultValue}
        disabled={disabled}
        className="formcontrol"
        {...rest}
      />
    </div>
  );
});
TextInputComponent.displayName = 'TextInputComponent';

Registry.register('MyTextInput', TextInputComponent);
Registry.register('MySpaceComponent', SpaceComponent);
Registry.register('RichEditor', RichEditor);
Registry.register(
  "RichTextEditorField",
  RichTextEditorField
);

/* ----- toolbar items (unchanged) ----- */


const items = [
  {
    key: 'Header',
    name: 'Header text',
    icon: 'fas fa-heading',
    static: true,
    content: 'Headline',
  },
  // {
  //   key: 'Label',
  //   name: 'Label',
  //   static: true,
  //   icon: 'fas fa-font',
  //   content: 'placeholder-label',
  // },
  
  {
    key: 'TextArea',
    canHaveAnswer: true,
    name:  'Multi-line-input' ,
    label: 'place-holder-label' ,
    icon: 'fas fa-text-height',
    field_name: 'text_area_',

    props: {
      rows: 6, // ✅ This sets the default height
      placeholder: 'Enter your description here...',
    },

  },
  
  // {
  //   key: 'MultiLine',
  //   canHaveAnswer: true,
  //   name:  'multi-line-input' ,
  //   label: 'place-holder-label' ,
  //   icon: 'fas fa-text-height',
  //   field_name: 'multiline',
  // },

  {
    key: 'Paragraph',
    name: 'Paragraph',
    static: true,
    icon: 'fas fa-paragraph',
    content: 'Paragraph'
  },
  {
    key: 'LineBreak',
    name: 'line-break',
    static: true,
    icon: 'fas fa-arrows-alt-h',
  },
  {
    key: 'MyTextInput',
    value:'',
    element: 'CustomElement',
    component: TextInputComponent,
    type: 'custom',
    forwardRef: true,
    field_name: 'my_input_',
    name: 'Text Input',
    icon: 'fa fa-font',
    props: { test: 'test_input' },
    label: 'Input label',
    tips:false, 
    toolTip:false,
    
    // customLabelName: 'Label Name'
  },
  {
    key: 'MySpaceComponent',
    value:'',
    component: SpaceComponent,
    element: 'CustomElement',
    heightValue: 16,
    icon: 'fa fa-rocket',
    name: 'Space',
    type: 'custom',
  },
  // {
  //   key: 'TextInput',
  //   name: 'Text Input',
  //   icon: 'fa fa-font',
  //   static: false,
  //   tooltips:'true',
  //   summary:''
  // },
  // {
  //   key: 'TextArea',
  //   canHaveAnswer: true,
  //   name: 'TextArea' ,
  //   label: 'place-holder-label' ,
  //   icon: 'fas fa-text-height',
  //   field_name: 'text_area_',
  // },


  // {
  //   key: 'Tags',
  //   canHaveAnswer: true,
  //   name: 'tags',
  //   icon: 'far fa-caret-square-down',
  //   label: 'place holder label',
  //   field_name: 'tags_',
  //   options: [],
  // },
  {
    key: 'Dropdown',
    tips:false,
    toolTip:false,
    canHaveAnswer: true,
    name: 'Dropdown',
    icon: 'far fa-caret-square-down',
    label: 'Dropdown label',
    field_name: 'dropdown_',
    options: [],
  },
  {
    key: 'Checkboxes',
    tips:false,
    toolTip:false,
    canHaveAnswer: true,
    name: 'Checkboxes Multiple Choice',
    icon: 'far fa-check-square',
    label: 'Checkbox label',
    field_name: 'checkboxes_',
    options: [],
  },
  {
    key: 'RadioButtons',
    tips:false,
    toolTip:false,
    canHaveAnswer: true,
    name: 'Radio Multiple Choice',
    icon: 'far fa-dot-circle',
    label: 'Radio label',
    field_name: 'radiobuttons_',
    options: [],
  },
  {
    key: 'Rating',
    tips:false,
    value:"",
    // canHaveAnswer: false,
    name: 'Rating',
    label: 'Rating label',
    icon: 'fas fa-star',
    field_name: 'rating_',
    toolTip: false,
    toolTipSummary: '',
    required: 'false',
    threshold: 0,
    weight:0,
    failEffect:'None',
  },
  // {
  //   key: 'RichEditor',
  //   element: 'CustomElement',
  //   label: 'Rich Editor Label',
  //   icon: 'fas fa-edit',
  //   forwardRef: true,
    
  //   component: RichEditor,
  //   type: 'custom',
  //   static: false,
  //   field_name: 'richeditor_field',
  //   name: 'Rich Text Editor',
  //   props: {
  //     label: 'Rich Text',
  //   },
  // },

  {
    key:'DatePicker',
    canDefaultToday: true,
    canReadOnly: true,
    dateFormat: 'MM/dd/yyyy',
    timeFormat: 'hh:mm aa',
    showTimeSelect: false,
    showTimeSelectOnly: false,
    showTimeInput: false,
    name:  'Date' ,
    icon: 'far fa-calendar-alt',
    label: 'place-holder-label' ,
    field_name: 'date_picker_',
  },


{
    key: "RichTextEditorField",
    element: "CustomElement",
    component: RichTextEditorField,
    type: "custom",
    forwardRef: true,
    bare: true,
    field_name: "rich_text_editor_",
    name: "Rich Text Editor",
    text: "Rich Text Editor",
    label: "Rich Text Editor",
    icon: "fa fa-file-text-o",
    static: false,
    required: false,
    canHaveAnswer: true,
    props: {
      placeholder: "Enter rich text content...",
    },
  },


];

const Formbuilder = (props) => {
  const {
    classes,
    onSave,
    setScoreCardTemplatebuilderFormData,
    setScorecardJSONRowFormData,
    btnDisable,
    sendJsonArrOfObjDataToChild,
    mode,
    isLoading,
  } = props || {};

  /** Single source of truth for builder schema */
  const [builderFormData, setBuilderFormData] = useState([]); // array of elements
  const firstLogDone = useRef(false);

  /** Subscribe to ElementStore to keep builderFormData current */
  useEffect(() => {
    const unsubscribe = ElementStore.subscribe((state) => {
      if (!firstLogDone.current) {
        // console.log('1st time only render from build state Eff', state);
        firstLogDone.current = true;
      }
      const arr = Array.isArray(state?.data) ? state.data : [];
      setBuilderFormData(arr);
    });
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  /** Initialize for edit mode on mount (populate both ReactFormBuilder and our state) */
  useEffect(() => {
    if (mode === 'edit' && Array.isArray(sendJsonArrOfObjDataToChild)) {
      setBuilderFormData(sendJsonArrOfObjDataToChild);
    }
    // run only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Save handler (returns current schema) */
  const handleSave = useCallback(() => {
    onSave(Array.isArray(builderFormData) ? builderFormData : []);
  }, [onSave, builderFormData]);

  /** Capture builder changes via onPost if your fork emits it per change */
  const onHandleCaptureUpdateData = useCallback((dataList) => {
    const next = Array.isArray(dataList)
      ? dataList
      : Array.isArray(dataList?.task_data)
      ? dataList.task_data
      : [];

    console.log('Updated schema from builder (onPost):', next);

    // Extract only items that have "weight"
    const filteredArrayWeight = next.filter((obj) => obj && 'weight' in obj);

    setScoreCardTemplatebuilderFormData(filteredArrayWeight);
    setScorecardJSONRowFormData(next);

    // If your fork fires onPost for every change, uncomment:
    // setBuilderFormData(next);
  }, [setScoreCardTemplatebuilderFormData, setScorecardJSONRowFormData]);

  /** Derived disable state */
  const disableActions = btnDisable || isLoading || !Array.isArray(builderFormData) || builderFormData?.length === 0;

  return (
    <div className={classes.formBuilderCustomise}>
      {/* Pass the single source of truth to Preview */}
      <FormbuilderPre
        classes={classes}
        mode={mode}
        data={builderFormData}
      />

      <ReactFormBuilder
        toolbarItems={items}
        className="formbuilderclasses"
        edit={mode === 'edit'}
        // Pre-populate when editing
        data={mode === 'edit' ? sendJsonArrOfObjDataToChild : null}
        renderEditForm={(props1) => <FormElementsEdit {...props1} />}
        onPost={onHandleCaptureUpdateData}
      />

      <button
        type="button"
        disabled={disableActions  }
        className={classes.viewlink}
        onClick={handleSave}
      >
        Save Form
      </button>
    </div>
  );
};

export default withStyles(styles)(Formbuilder);
